import React from 'react';
import { Link } from 'react-router-dom';
import './navMenu.css';

function NavMenu({ onNavigate }) {
    return (
        <div className="nav-container">
            <div className='nav-list'>
                <ul className='nav-list-items'>
                    <li className='nav-list-item'>
                        <Link to="/creations" onClick={onNavigate}>Créations</Link>
                    </li>
                    <li className='nav-list-item'>
                        <Link to="/lookbooks" onClick={onNavigate}>Lookbooks</Link>
                    </li>
                    <li className='nav-list-item'>
                        <Link to="/blog" onClick={onNavigate}>Blog</Link>
                    </li>
                    <li className='nav-list-item'>
                        <Link to="/about" onClick={onNavigate}>À propos</Link>
                    </li>
                    <li className='nav-list-item'>
                        <Link to="/contact" onClick={onNavigate}>Contact</Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default NavMenu;